export default "__VITE_ASSET__52f95e9c__"